import { Button, createStyles, Group, Text } from '@mantine/core';
import React from 'react';

import { NameAbbreviationAvatar } from '@portals/core';
import { usePortalProtocolAndDomain } from '@portals/framework';

interface CustomerViewHeaderProps {
  customerName: string;
  isControlled: boolean;
  customerId: string;
  customerLogoUrl: string | null;
}

export function CustomerViewHeader({
  customerName,
  isControlled,
  customerId,
  customerLogoUrl,
}: CustomerViewHeaderProps) {
  const { classes } = useStyles();
  const { protocolAndDomain } = usePortalProtocolAndDomain();

  return (
    <Group position="apart" mt={110}>
      <Group spacing="sm" align="end">
        <NameAbbreviationAvatar
          name={customerName}
          size={108}
          radius={76}
          src={customerLogoUrl}
        />
        <Text weight={600} sx={{ fontSize: 28 }}>
          {customerName}
        </Text>
      </Group>

      {isControlled && (
        <Button<'a'>
          component="a"
          href={`${protocolAndDomain}?org=${customerId}`}
          target="_blank"
          className={classes.visitPortalLink}
        >
          Visit Portal
        </Button>
      )}
    </Group>
  );
}

const useStyles = createStyles((theme) => ({
  visitPortalLink: {
    alignSelf: 'end',

    '&:hover': {
      color: theme.white,
      textDecoration: 'none',
    },
  },
}));
